import { Icon, ISelectOption, SearchBolder, TableColumn, TableRow, Tooltip } from '@aon/aon-tws-common-ui';
import { ResponseOptionsTooltipContainer } from '@aon/tws-common-ui-questions';
import * as React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { IColumn, ICustomQuestion, IExternalAttributeVm } from '../../../models';

export const EditIconContainer = styled.div`
	cursor: pointer;
`;

export interface ICustomQuestionRowProps {
	availableCultures: ISelectOption[];
	columns: IColumn[];
	disabled: boolean;
	mappedAttribute?: IExternalAttributeVm;
	parentQuestionId?: number;
	question: ICustomQuestion;
	searchText?: string;
	surveySupportedCultures: string[];
	selectedCustomQuestionIds: number[];
	editQuestion: (questionId: number) => void;
	SelectQuestion: (question: ICustomQuestion, isSelected: boolean, parentQuestionId?: number) => void;
}

export class CustomQuestionRow extends React.PureComponent<ICustomQuestionRowProps> {
	constructor(props: ICustomQuestionRowProps) {
		super(props);

		this.handleSelectQuestion = this.handleSelectQuestion.bind(this);
	}

	public render() {
		const isSelected = this.props.selectedCustomQuestionIds.indexOf(this.props.question.questionId) > -1;
		return (
			<>
				<TableRow
					selected={isSelected}
					disabled={this.props.disabled}
					selectable={true}
					onSelectRow={() => this.handleSelectQuestion(this.props.question, !isSelected)}
					key={this.props.question.code}
					record={this.props.question}
				>
					{_(this.props.columns)
						.orderBy('displayOrder')
						.map((column: IColumn) => this.getQuestionPropertyText(column, isSelected))
						.value()}
				</TableRow>
			</>
		);
	}

	private getQuestionPropertyText(column: IColumn, isSelected: boolean) {
		const { question, searchText } = this.props;

		const key = question.questionId + '_' + column.name.toLowerCase();
		switch (column.name) {
			case 'text': {
				const text = question.text === '' ? '--' : question.text;
				return (
					<TableColumn key={key}>
						<SearchBolder text={text} searchText={searchText} />
					</TableColumn>
				);
			}
			case 'responseOptions':
				return (
					<TableColumn key={key}>
						<ResponseOptionsTooltipContainer
							id={this.props.question.questionId}
							invertedTooltip={isSelected}
							questionType={question.questionType}
							responseOptionGroup={this.props.question.responseOptionGroup}
							responseOptions={this.props.question.responseOptions}
						/>
					</TableColumn>
				);
			case 'mappedAttribute':
				return <TableColumn key={key}>{this.props.mappedAttribute !== undefined && this.props.mappedAttribute.displayName}</TableColumn>;
			case 'translations': {
				const missingLanguages = this.getMissingLanguages();
				const tooltipLangId = this.props.question.questionId + '_translations';
				return (
					<TableColumn key={key}>
						{missingLanguages.length === 0 ? (
							<Icon name='yes' />
						) : (
							<>
								{missingLanguages.length + ' missing '}
								<Tooltip id={tooltipLangId} iconName='error' contentType='jsx' inverted={isSelected}>
									<div>
										<p>
											<strong>{ContentConstants.MISSING_LANGUAGES_TOOLTIP_TITLE_TEXT}</strong>
										</p>
										<ul>
											{missingLanguages.map((id, index) => {
												const culture = this.props.availableCultures.find((c) => c.name === id);
												return <li key={index}>{culture ? culture.displayText : id}</li>;
											})}
										</ul>
										<br />
										{ContentConstants.MISSING_LANGUAGES_TOOLTIP_REMINDER_TEXT}
									</div>
								</Tooltip>
							</>
						)}
					</TableColumn>
				);
			}
			case 'actions':
				return (
					<TableColumn key={key}>
						<EditIconContainer onClick={() => this.props.editQuestion(this.props.question.questionId)}>
							<Icon name='edit' />
						</EditIconContainer>
					</TableColumn>
				);
		}
	}

	private getMissingLanguages(): string[] {
		const { surveySupportedCultures, question } = this.props;

		return surveySupportedCultures.filter((code) => question.languages.indexOf(code) === -1);
	}

	private handleSelectQuestion(question: ICustomQuestion, isSelected: boolean) {
		const { parentQuestionId, SelectQuestion } = this.props;
		SelectQuestion(question, isSelected, parentQuestionId);
	}
}
